<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection>
            <div class="text-right">
              <ArgonButton :to="{ name: 'User' }" isRouteLink>
                Kembali</ArgonButton>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
          <form action="" @submit.prevent="save()">
            <cards title="Form Pengguna" headerstyle="background-color: #ebeffb;" footerstyle="background-color: #ebeffb;"
              :useFooter="true" withmin>
              <template v-slot:footer>
                <div class="text-right">
                  <div class="d-flex flex-row-reverse gap-2">
                    <ArgonButton>Simpan</ArgonButton>
                    <ArgonButton :to="{ name: 'User' }" outline isRouteLink>Batalkan</ArgonButton>
                  </div>
                </div>
              </template>
              <form>
                <FieldsetComponent title="Informasi Pegawai"
                  description="Isi kolom disamping dengan baik dan benar agar data pegawai tercatat dalam aplikasi">
                  <div class="flex flex-col gap-5">
                    <FormGroup label="Nama" idinput="name">
                      <input type="text" name="name" id="name" class="form-control" v-model="data.name" disabled>
                    </FormGroup>

                    <FormGroup label="NIP" idinput="nip">
                      <input type="text" name="nip" id="nip" class="form-control" v-model="data.username" disabled>
                    </FormGroup>

                    <FormGroup label="Email" idinput="email">
                      <input type="email" name="email" id="email" class="form-control" v-model="data.email">
                    </FormGroup>

                    <FormGroup label="Deskripsi" idinput="desc">
                      <input type="text" name="desc" id="desc" class="form-control"
                        v-model="data.desc">
                    </FormGroup>

                    <FormGroup label="Hak Akses" idinput="hakases">
                      <select-form v-model="data.group_id" :options="groups.map((item) => {
                        return {
                          text: item.name,
                          value: item.id
                        }
                      })" />
                    </FormGroup>

                    <form-group label="Status">
                      <div class="d-flex flex-row gap-4 align-items-center">
                        <argon-radio id="status_0" name="status" text="Aktif" v-model="data.is_active" :value="true" />
                        <argon-radio id="status_1" name="status" text="Non Aktif" v-model="data.is_active" :value="false" />
                      </div>
                    </form-group>

                  </div>
                </FieldsetComponent>

                <FieldsetComponent title="Informasi Jabatan" description="Pastikan informasi ini diisi dengan tepat sesuai jabatan pegawai">
                  <FormGroup label="Unit Kerja" idinput="unitkerja_id">
                    <div class="form-control" style="background-color: rgb(234 236 239);border-color: aliceblue;pointer-events: none;">
                      {{ data.employee?.unitkerja?.name ?? "&nbsp;" }}
                    </div>
                  </FormGroup>

                  <FormGroup label="Jabatan" idinput="jabatan_id">
                    <div class="form-control" style="background-color: rgb(234 236 239);border-color: aliceblue;pointer-events: none;">
                      {{ data.employee?.jabatan?.name ?? "&nbsp;" }}
                    </div>
                  </FormGroup>
                </FieldsetComponent>

                <FieldsetComponent title="Informasi Kata Sandi" description="Silakan buatkan kata sandi untuk anggota, pastikan aman dan tidak mudah ditebak">
                  <FormGroup label="Kata Sandi" idinput="password">
                    <input-form type="password" name="password" id="password" v-model="data.password" />
                    <checklist-password :data="data.password" />
                  </FormGroup>
                  <FormGroup label="Konfirmasi Kata Sandi" idinput="repassword">
                    <input-form type="password" name="repassword" id="repassword" v-model="data.repassword" />
                  </FormGroup>
                </FieldsetComponent>
              </form>
            </cards>
          </form>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>

<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
import UsersApi from "@/repository/api/UsersApi";
import UnitKerjaApi from "@/repository/api/UnitKerjaApi";
import JabatanApi from "@/repository/api/JabatanApi";
// import Select2 from 'vue3-select2-component';
import FieldsetComponent from "@/components/FieldsetComponent.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from "@/components/MetaSection.vue";
import EmployeeApi from '@/repository/api/EmployeeApi';
import GroupsApi from "@/repository/api/GroupsApi";
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import ChecklistPassword from '@/components/ChecklistPassword.vue';
import SelectForm from '@/components/SelectForm.vue';
import InputForm from '@/components/InputForm.vue';
import ArgonRadio from "@/components/ArgonRadio.vue";

export default {
  name: "profile",
  data() {
    return {
      isEdit: false,
      showMenu: false,
      data: {},
      jabatan_id: "",
      unitkerja_id: "",
      employees: [],
      employee: {},
      unitKerja: [],
      jabatan: [],
      groups: [],
      employeeKeyword: "",
      url: "",
    };
  },
  components: {
    FieldsetComponent,
    Cards,
    FormGroup,
    // Select2,
    ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    ChecklistPassword,
    SelectForm,
    InputForm,
    ArgonRadio,
  },

  async mounted() {
    await this.getGroups();
    await this.getUnitKerja();
    if (this.$route.params.id) {
      this.isEdit = true;
      await this.getData();
    }
    this.$store.state.isAbsolute = true;
  },
  methods: {
    onChangePhoto(e) {
      const file = e.target.files[0];
      this.url = URL.createObjectURL(file);
    },
    async pilihEmployee(item) {
      this.$store.state.loading = true;
      this.employee = item;
      this.data.username = this.employee?.nip;
      let name = String(this.employee.name).split(" ")
      this.data.first_name = name.splice(0, 1)[0]
      this.data.last_name = name.join(' ')
      this.data.name = this.employee.name
      this.data.unitkerja_id = await (this.employee?.jabatan?.unitkerja_id ?? null)
      await this.getJabatan();
      this.data.jabatan_id = this.employee?.jabatan?.id ?? null
      this.$store.state.loading = false;
    },
    async searchEmployee() {
      this.$store.state.loading = true;
      if (this.employeeKeyword.length > 3) {
        await EmployeeApi.getByKeyword(this.employeeKeyword).then((response) => {
          this.employees = response.data;
        }).catch(() => {
          this.$swal({
            icon: "error",
            title: "Data tidak ditemukan",
          });
        });
      }
      this.$store.state.loading = false;
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      await UnitKerjaApi.get().then(async (response) => {
        this.unitKerja = response.data;
      }).catch(() => {
        this.unitKerja = []
      });
      this.$store.state.loading = false;
    },
    async getJabatan() {
      this.$store.state.loading = true;
      await JabatanApi.getbyparam({ unitkerja_id: this.unitkerja_id }).then((response) => {
        this.jabatan = response.data;
      }).catch(() => {
        this.jabatan = [];
      });
      this.$store.state.loading = false;
    },
    async save() {
      this.$store.state.loading = true;
      if (this.$route.params.id) {
        await UsersApi.update(this.$route.params.id, this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "User" });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "ERROR",
              text: typeof error?.response?.data?.message == String ? error?.response?.data?.message : "Gagal menyimpan",
            });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: "Gagal Menyimpan",
            text: (typeof error?.response?.data?.message) == "string" ? error?.response?.data?.message : ""
          });
        });
      }
      else {
        await UsersApi.post(this.data).then(() => {
          this.$swal({
            icon: "success",
            title: "Berhasil",
          }).then(() => {
            this.$router.push({ name: "User" });
          });
        }).catch((error) => {
          this.$swal({
            icon: "error",
            title: "Gagal Menyimpan",
            text: (typeof error?.response?.data?.message) == "string" ? error?.response?.data?.message : ""
          });
        });
      }
      this.$store.state.loading = false;
    },
    async getData() {
      this.$store.state.loading = true;
      await UsersApi.get(this.$route.params.id).then(async (response) => {
        this.data = await response.data;
        this.unitkerja_id = this.data?.employee?.jabatan?.unitkerja_id ?? "";
        await this.getJabatan();
        this.jabatan_id = this.data?.employee?.jabatan?.id ?? "";
      }).catch((error) => {
        this.$swal({
          icon: "error",
          title: error.response.data.message,
        }).then(() => {
          this.$router.push({ name: "Dashboard" });
        });
      })
      this.$store.state.loading = false;
    },
    async getGroups() {
      this.$store.state.loading = true;
      await GroupsApi.get().then((response) => {
        this.groups = response.data
        this.groups = this.groups.filter((item) => {
          return item.status == 1
        })
      }).catch(() => {
        this.groups = []
      })
      this.$store.state.loading = false;
    }
  },
};
</script>
